import React, { useEffect, useState } from "react"
import { Container, Card, CardBody } from "reactstrap"
import secureLocalStorage from "react-secure-storage"
import Breadcrumbs from "components/Common/Breadcrumb"
import Loader from "pages/Separate/Loader"
import { fetchNodeData } from "utils/common-fetchData"
import "./GuidelinesPolicy.css"

// Read-only page where every user can go through the company guidelines and policy
const GuidelinesPolicy = () => {
  const [isLoading, setLoading] = useState(false)
  const [content, setContent] = useState("")

  document.title = "Guidelines & Policy | Zithas Crm"

  useEffect(() => {
    const getPolicy = async () => {
      const response = await fetchNodeData(
        setLoading,
        "companyPolicy/get",
        secureLocalStorage.getItem("auth_token")
      )
      setContent(response?.data?.content || "")
    }
    getPolicy()
  }, [])

  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <div className="page-content mb-4">
        <Container fluid>
          <Breadcrumbs
            title="Dashboard"
            breadcrumbItem="General Guidelines & Policy"
          />
          {/* About this section: kept in its own box so it doesn't read as part of the policy */}
          <div
            className="alert alert-info d-flex align-items-start mb-3"
            role="alert"
          >
            <i className="bi bi-info-circle-fill font-size-18 me-3"></i>
            <div>
              <h6 className="alert-heading mb-1">About this section</h6>
              <p className="mb-0">
                This section explains the general guidelines and company
                policies that apply to everyone working here. Please read it
                carefully and follow it in your day-to-day work. It is updated
                by the management from time to time, so check back here
                whenever you are unsure about a rule or process.
              </p>
            </div>
          </div>
          <Card>
            <CardBody className="p-4">
              <h5 className="text-dark mb-3 pb-3 border-bottom">
                General Guidelines & Policy
              </h5>
              {content ? (
                <div
                  className="guidelines-policy-content text-dark"
                  dangerouslySetInnerHTML={{ __html: content }}
                />
              ) : (
                !isLoading && (
                  <p className="text-center text-muted py-5 mb-0">
                    No guidelines or policy have been added yet.
                  </p>
                )
              )}
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default GuidelinesPolicy
